import { render, staticRenderFns } from "./ApplicationDocuments.vue?vue&type=template&id=bf6dbf56"
import script from "./ApplicationDocuments.vue?vue&type=script&lang=js"
export * from "./ApplicationDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports